import ContainedIcon from '@/components/ContainedIcon';
import BasetenIconBase from '@/components/Icons/BasetenIcon';

function BasetenIcon() {
  return (
    <ContainedIcon size={24} color="#19E76E" borderRadius={6}>
      <BasetenIconBase
        sx={{
          width: 12,
          height: 12,
          color: 'black',
        }}
      />
    </ContainedIcon>
  );
}

export default BasetenIcon;
